import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PrinciplesSection from './components/PrinciplesSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <PrinciplesSection />
      <ContactSection />
    </main>
  );
}